const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Working Hours',
        },
      },
    },
  },
};

export default layout;
